
import isString from 'lodash/isString';

export default function parseFloatCz(value) {
    return isString(value)
        ? parseFloat(value.replace(',', '.'))
        : value;
}
